import React from 'react';
import { Link } from 'react-router-dom';
import { useVariant } from '../../contexts/VariantContext';
import { useTheme } from '../../contexts/ThemeContext';
import SafeLogo from '../SafeLogo';
import DomainIcon from '../DomainIcon';

const VariantFooter = () => {
  const { variant, styles } = useVariant();
  const { brand, pages } = useTheme();

  const navigation = {
    company: [
      ...(pages.includes('about') ? [{ name: 'About', href: '/about' }] : []),
      { name: 'Solutions', href: '/solutions' },
      ...(pages.includes('products') ? [{ name: 'Products', href: '/products' }] : []),
      ...(pages.includes('testimonials') ? [{ name: 'Testimonials', href: '/testimonials' }] : []),
    ],
    resources: [
      ...(pages.includes('blog') ? [{ name: 'Blog', href: '/blog' }] : []),
      ...(pages.includes('resources') ? [{ name: 'Resource Center', href: '/resources' }] : []),
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy' },
    ],
    social: [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/fleethosterUSA/',
        icon: (props) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path
              fillRule="evenodd"
              d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
              clipRule="evenodd"
            />
          </svg>
        ),
      },
      {
        name: 'Instagram',
        href: 'https://www.instagram.com/fleethoster/',
        icon: (props) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
          </svg>
        ),
      },
      {
        name: 'X',
        href: 'https://x.com/FleetHoster',
        icon: (props) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        ),
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/fleethoster/posts/?feedView=all',
        icon: (props) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
          </svg>
        ),
      },
    ],
  };


  return (
    <footer 
      className={`${styles.footer} py-12`} 
      aria-labelledby="footer-heading"
      style={variant === 'grid' ? { backgroundColor: '#195A8E' } : {}}
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-8 xl:col-span-1">
            <div className="flex items-center">
              <SafeLogo
                context="footer"
                className="h-12 w-auto rounded-lg p-1"
                alt={brand.name}
              />
            </div>
            <p className={`${styles.footerTextSecondary || styles.textSecondary} text-lg leading-relaxed`}>
              {brand.description}
            </p>
            {/* <div className="flex space-x-5">
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${styles.footerLink || styles.link} transition-colors duration-200 group`}
                  aria-label={item.name}
                >
                  <span className="sr-only">{item.name}</span>
                  <div className="p-2 rounded-full bg-white/5 group-hover:bg-white/10 transition-colors duration-200">
                    <item.icon className="h-5 w-5" aria-hidden="true" />
                  </div>
                </a>
              ))}
            </div> */}
          </div>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 xl:mt-0 xl:col-span-2">
            <div>
              <h3 className={`text-base font-semibold uppercase ${styles.footerAccent || styles.accent}`}>
                Company
              </h3>
              <ul className="mt-4 space-y-3">
                {navigation.company.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      className={`text-base ${styles.footerLink || styles.link} transition-colors duration-200`}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className={`text-base font-semibold uppercase ${styles.footerAccent || styles.accent}`}>
                Resources
              </h3>
              <ul className="mt-4 space-y-3">
                {navigation.resources.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      className={`text-base ${styles.footerLink || styles.link} transition-colors duration-200`}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className={`text-base font-semibold uppercase ${styles.footerAccent || styles.accent}`}>
                Legal
              </h3>
              <ul className="mt-4 space-y-3">
                {navigation.legal.map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      className={`text-base ${styles.footerLink || styles.link} transition-colors duration-200`}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-white/20 pt-8">
          <div className="flex items-center justify-center">
            <DomainIcon 
              className="h-6 w-auto mr-2 rounded-md"
              alt={`${brand.name} Icon`}
            />
            <p className={`text-base text-center ${styles.footerTextSecondary || styles.textSecondary}`}>
              &copy; {new Date().getFullYear()} {brand.name}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default VariantFooter;
